module.exports = __webpack_public_path__ + "static/media/image5.16670429.jpg";